import { routeTree } from "@/gen/routeTree.gen";
import { createRouter } from "@tanstack/react-router";
import { queryClient } from "./lib/react-query";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";

export function getRouter() {
	const router = createRouter({
		routeTree,
		defaultPreload: "intent",
		scrollRestoration: true,
		context: { queryClient },
	});

	setupRouterSsrQueryIntegration({
		router,
		queryClient,
	});

	return router;
}

// Register things for typesafety
declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}
